import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function pushToDataLayer(payload: Record<string, any>) {
  if (typeof window === "undefined") {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
}

export function trackVirtualPageView() {
  pushToDataLayer({
    event: "virtual_pageview",
    page_path: window.location.pathname,
    page_location: window.location.href,
    page_title: document.title,
  });
}
